module.exports = __webpack_public_path__ + "img/scope3category5.a79403f5.svg";